module.exports = __webpack_public_path__ + "static/img/icon-c-mine.84818f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-c-mine.png
// module id = qqvM
// module chunks = 21